const inputWithCurrPageValue = document.querySelector('.hiddenInputWithCurrPageValue')
const currPage = inputWithCurrPageValue && inputWithCurrPageValue.value
const currButton = currPage && document.querySelector(`.page-button-${currPage}`)

const spanToReplace = document.createElement('span')

if (spanToReplace && currButton) {
    spanToReplace.innerHTML = currButton.innerHTML
    spanToReplace.classList.add('page-numbers', 'current')
    spanToReplace.setAttribute('aria-current', 'page')
    currButton.parentNode.replaceChild(spanToReplace, currButton);
}